const appConfig = {
    appId: "dealerQore-5d9f0326-5950-47a8-ae1c-bf353f668f77",
    appName: "Dealer",
    site: 'dealer-qore',
    icon: "https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/dealerQoreAppIcon.png"
};

export default appConfig;
